import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const cssModal = css`
  ${({ theme }) => theme.media.mobile} {
    width: 100%;
    max-width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    transform: translate3d(0, 0, 0);
  }
`;

export const Wrapper = styled.div`
  width: 375px;
  height: 600px;
  background: #fff;
  border-radius: 4px;
  padding: 56px 24px 48px;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const Title = styled.h3`
  margin-bottom: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray800};
  ${getFontStyle('bold150_H5')};
`;

export const ScrollableContents = styled.div`
  width: 100%;
  height: 440px;
  overflow: auto;
  padding: 24px 16px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};

  ${({ theme }) => theme.media.mobile} {
    height: calc(100vh - 190px);
  }
`;
